import React from 'react';
import { Header,
    ExamDetailsComponent, 
    SubjectDetails, 
    ScoreComponent } from './../../../components'
import ResultComponent from './resultsComponent';
import { connect } from "react-redux";
import {
  testAnalysis,
  clearTestAnalysisData,
  questionReport,
  clearQuestionReportData,
} from "./../../../store/actions";
import Collapse from '@material-ui/core/Collapse';
import moment from "moment";
import './results.scss';


class Results extends React.Component{
    render(){
       const {
        answers,
        wrongQuestions,
        correctAnswer,
        unansweredQuestions,
        score, userSubject,
        attemptUser,
        duration,
        totalMarks
       } = this.props;
        return(
            <>
              <Header/>
              <div className='w-100'>
                <div className='container-fluid'>
                    <div className='row p-0 ml-lg-2 ml-0'>
                        <div className ='col-12 mt-4 '>
                            <p class="h2" style={{color: '#000', }}>Results - Exam Name</p>
                        </div>
                       <div className='col-lg-9 col-12'>
                            <div className={`result_info 
                                    d-flex 
                                    flex-lg-row 
                                    flex-column 
                                    justify-content-lg-between 
                                    justify-content-center
                                    align-items-center
                                    `}>
                                    <ScoreComponent
                                    title={'wrong'}
                                    score={wrongQuestions}
                                    color={'#000'}
                                />
                                    <ScoreComponent
                                    title={'Answered'}
                                    score={correctAnswer}
                                    color={'#0DDE83'}
                                />
                                    <ScoreComponent
                                    title={'Un Answered'}
                                    score={unansweredQuestions}
                                    color={'#FC7F5F'}
                                />
                                    <ScoreComponent
                                    title={'Marks'}
                                    score={score}
                                    color={'#546CD0'}
                                />
                            </div>
                            <div className='mt-4 py-2 px-2'>

                            </div>
                            <ResultComponent answers={answers}/>
                       </div>
                       <div className='col-lg-2 ml-lg-4 ml-0 col-12'>
                         <ExamDetailsComponent 
                         duration={duration}
                         totalMarks={totalMarks}
                         examDate={attemptUser && moment(attemptUser.test_time ||attemptUser.attempt_date).format("DD-M-YYYY")}  
                          time = {attemptUser && moment(attemptUser.test_time ||attemptUser.attempt_date).format("hh:mm a")}  
                            className='exam_details d-flex flex-column align-items-center'/>
                         {/* <SubjectDetails subject = {(userSubject && userSubject) || "-"}  className='exam_details mt-2 d-flex flex-column align-items-center'/> */}
                   {/* /<SubjectDetails subject = {(userSubject && userSubject) || "-"}   className='exam_details mt-2 d-flex flex-column align-items-center'/> */}
                     </div>
                     <div className='col-lg-1 col-12'>

                     </div>
                    </div> 
                </div>
            </div> 
            </>
        )
    }
}

export default Results